"use strict";

import F7ToolbarRedefine from './toolbar';

PF.App = class Application extends PF.Entity
	{
	static get options()
		{
		return {
			prodUrl: '',
			devUrl: '',
			defaultRoute: '',
			mainViewConfig: {
				// pushState: true,
				// pushStateRoot: '/',
			},
			localeName: 'ru',
			f7Config: {
				init: false,
				root: '#app',
				calendar: {
					url: 'calendar/',
					routableModals: true,
					dateFormat: 'dd.mm.yyyy',
					monthNames: [
						'Январь',
						'Февраль',
						'Март',
						'Апрель',
						'Май',
						'Июнь',
						'Июль',
						'Август',
						'Сентябрь',
						'Октябрь',
						'Ноябрь',
						'Декабрь'
					],
					monthNamesShort: [
						'Янв',
						'Фев',
						'Март',
						'Апр',
						'Май',
						'Июнь',
						'Июль',
						'Авг',
						'Сент',
						'Окт',
						'Нояб',
						'Дек'
					],
					dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
					dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],

				}

			}
		};
		}

	init()
		{
		this.locale = PF.Locales[this.localeName];
		this.pageParams = new PF.EntityProxy();

		let pageParams = JSON.parse(window.localStorage.getItem('pageParams'));
		for (let key in pageParams)
			{
			this.pageParams[key] = pageParams[key];
			}
		this.pageParams.on('changeProperty', (key, value) => {
			console.log(this.pageParams.toJSON());
			window.localStorage.setItem('pageParams', JSON.stringify(this.pageParams.toJSON()));
		});

		if (document.readyState == 'loading')
			{
			document.addEventListener('DOMContentLoaded', this.DOMContentLoadedSlot.bind(this));
			}
		else
			{
			this.DOMContentLoadedSlot.bind(this);
			}
		}

	removeDynamicFromHistory()
		{
		console.log(window.location.hash);
		let hash = (window.location.hash + '').split('/');
		while (hash[hash.length - 1].startsWith('popup-') || hash[hash.length - 1].startsWith('dynamic-'))
			{
			hash.pop();
			console.log(hash);
			}
		hash = hash.join('/');

		let history = JSON.parse(window.localStorage.getItem('f7router-view_main-history')) || [];
		for (let i = history.length - 1; i >= 0; i--)
			{
			if (history[i].indexOf('popup-') >= 0 || history[i].indexOf('dynamic-') >= 0)
				{
				history.splice(i, 1);
				}
			}
		window.location.hash = hash;
		window.history.replaceState({view_main: {url: hash.substr(2)}}, '');
		window.localStorage.setItem('f7router-view_main-history', JSON.stringify(history));
		}

	DOMContentLoadedSlot()
		{
		this.collectRoutes();

		this.removeDynamicFromHistory();

		this.dom.app = PF.Dom.Node.findOne('#app');

		this.f7Config.routes = this.routes;
		this.f7 = new Framework7(this.f7Config);

		F7ToolbarRedefine();

		this.f7.on('init', () => {
			console.log('f7init');
			this.trigger('app-loaded');
		});

		this.mainView = this.f7.views.create('.view-main', this.mainViewConfig);
		this.router = this.mainView.router;
		// this.router.routes = this.routes;

		// this.f7.init();


		// this.trigger('app-loaded');
		}

	collectRoutes()
		{
		for (let pageName in App.Pages)
			{
			this.routes.push(App.Pages[pageName].collectComponent(App.Pages[pageName], pageName));
			}
		}

	makeUrl(url)
		{
		if (url.startsWith('/'))
			{
			if (window.location.origin === this.devUrl)
				{
				url = this.devUrl + url;
				}
			else
				{
				url = this.prodUrl + url;
				}
			}
		return url;
		}

	// ajax(url, data, callback, errorCallback = () => {
	// })
	// 	{
	// 	url = this.makeUrl(url);
	// 	$.ajax(url, {
	// 		dataType: 'json',
	// 		data: JSON.stringify(data),
	// 		method: 'POST',
	// 		success: callback,
	// 		contentType: "application/json; charset=utf-8",
	// 		error: (jqXHR, textStatus, thrown) => {
	// 			if (app.f7 !== undefined)
	// 				{
	// 				app.f7.preloader.hide();
	// 				}
	// 			if (jqXHR.status === 403)
	// 				{
	// 				this.toast("Недостаточно прав доступа");
	// 				app.router.navigate(this.defaultRoute);
	// 				}
	// 			else
	// 				{
	// 				this.toast("Сервер не доступен. Проверьте интернет соединение или повторите позже" + "<br/>" + jqXHR.status + "</br>" + thrown);
	// 				}
	// 			console.log(jqXHR);
	// 			let saveErrorUrl = app.makeUrl('/logger/save-request-error');
	// 			$.ajax(saveErrorUrl, {
	// 				// crossDomain: true,
	// 				dataType: 'json',
	// 				data: {
	// 					status: jqXHR.status,
	// 					url: url,
	// 					responseJSON: jqXHR.responseJSON,
	// 					requestData: data
	// 				},
	// 				method: 'POST',
	// 				success: (response) => {
	// 				},
	// 				error: (jqXHR, textStatus, thrown) => {
	// 				},
	// 			});
	// 			errorCallback(jqXHR.status, textStatus);
	// 		},
	// 	});
	// 	}

	request(url, data, callback, errorCallback)
		{
		url = app.makeUrl(url);
        try {
			fetch(url, {
				headers: {
					'Accept': 'application/json, text/javascript, */*; q=0.01',
					'Content-Type': 'application/json; charset=UTF-8'
				},
				method: "POST",
				body: JSON.stringify(data)
			})
				.then((response) => {
						if (response.status == 200)
							{
								try
								{
									response.json().then(callback);
								} catch (error) 
								{
									errorCallback();
								}
							}
						else
							{
								console.log(response);
								errorCallback();
							}
					}
				)
				.catch((err) => {
					console.log('Fetch Error :-S', err);
				});
        } catch (e) {
            console.log("url error request", e);
			this.toast("Ошибка на стороне сервера, попробуйте повторить запрос позже");
        }
		}

	toast(text)
		{
		this.f7.toast.create({
			text: text,
			closeTimeout: 3000,
		}).open();
		}
	};

App.Pages = {};


// window.onerror = function errorHandler(errorMsg, url, lineNumber, colNumber, error) {
//
// 	if (window.localStorage.getItem('mode') === 'debug')
// 		{
// 		return;
// 		}
//
// 	url = app.makeUrl('/logger/save-js-error');
//
// 	$.ajax(url, {
// 		// crossDomain: true,
// 		dataType: 'json',
// 		data: {
// 			errorMsg: errorMsg,
// 			url: window.location.href + "/" + window.location.hash,
// 			lineNumber: lineNumber,
// 			colNumber: colNumber,
// 			stack: error.stack
// 		},
// 		method: 'POST',
// 		success: (response) => {
// 		},
// 		error: (jqXHR, textStatus, thrown) => {
// 		},
// 	});
//
// 	return false;
// };